import { Stack, Typography } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { formatPrice } from '@retail/products/utils';
import { useTranslation } from 'react-i18next';

interface Props {
  salesPrice?: number;
  salesCoverage?: number;
  packageUnit: string;
  incVat: boolean;
}

export function SalesPriceSummary({ salesPrice, salesCoverage, packageUnit, incVat }: Props) {
  const t = useMyAssortmentTFunction();
  const { i18n } = useTranslation();
  return (
    <Stack>
      <Stack bgcolor="grey.50" height={50} justifyContent="center" px={2}>
        {t('myAssortment.productCard.salesPrice.price').toUpperCase()}
      </Stack>

      <Stack py={1} px={2} gap={2}>
        <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
          <Stack flexDirection="row" gap={1} alignItems="center">
            <Typography variant="body2">
              {t('myAssortment.salesPricePer', { unit: packageUnit })}{' '}
              {incVat ? t('myAssortment.columns.incVat') : t('myAssortment.columns.exVat')}
            </Typography>
          </Stack>
          <Typography variant="body2">
            {t('myAssortment.productCard.price', {
              price: salesPrice ? formatPrice(salesPrice, i18n.language) : '-',
            })}
          </Typography>
        </Stack>
        <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
          <Typography variant="body2">{t('myAssortment.salesCoverage')}</Typography>
          <Typography variant="body2">
            {salesCoverage
              ? `${formatPrice(Number(salesCoverage.toFixed(2)), i18n.language)}%`
              : '-'}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
